"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ceilToXMinutes = exports.secondsTimeFormatted = exports.secondsToDays = exports.daysToSeconds = void 0;
const moment_mini_1 = __importDefault(require("moment-mini"));
const daysToSeconds = (days) => days * 24 * 60 * 60;
exports.daysToSeconds = daysToSeconds;
const secondsToDays = (seconds) => Math.ceil(seconds / 24 / 60 / 60);
exports.secondsToDays = secondsToDays;
const secondsTimeFormatted = (seconds) => moment_mini_1.default.utc(seconds * 1000).format('HH:mm:ss');
exports.secondsTimeFormatted = secondsTimeFormatted;
const ceilToXMinutes = (time, minutes) => {
    return time.set('minutes', Math.ceil(time.minutes() / minutes) * minutes);
};
exports.ceilToXMinutes = ceilToXMinutes;
